/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as checkoutActionTypes from './Pages-ActionTypes';

export const appProcessPage = (page, history, pageData) => ({
    type: checkoutActionTypes.APP_PAGE_PROCESS,
    data: {
        page,
        history,
        pageData,
    },
});

export default {};
